import React from 'react';
import { LinkButton, Typography } from 'fronton-react';
import { addSlashToEndString, patchUrlByLocale } from 'utils';
import { CategoryItem } from './types';
import { AccordionList } from '../accordion-list';
import { ImagePlaceholder } from '../image-placeholder';
import { clickEvent } from '../utils';
import {
  category,
  categoryImage,
  categoryLabel,
  categoryLink,
  imageLink,
  subcategoryItem,
  subcategoryList,
} from './styles';

export const DATA_QA_CATEGORY_ITEM = 'category-item';

const ImageFallBack = () => <div className={categoryImage} />;

export const CategoriesItem: React.FC<CategoryItem> = ({
  titleImageRef,
  name: categoryName,
  children,
  sitePath: categoryPath,
  renderCount,
}) => {
  const href = patchUrlByLocale(addSlashToEndString(categoryPath));
  return (
    <li className={category} data-qa={DATA_QA_CATEGORY_ITEM}>
      <a
        href={href}
        data-qa="link-wrapper"
        className={imageLink}
        onClick={() => clickEvent(categoryName, 'divisionPhotoLink')}
      >
        <ImagePlaceholder
          src={titleImageRef}
          alt={categoryName}
          className={categoryImage}
          fallback={<ImageFallBack />}
        />
      </a>
      <div>
        <a
          className={categoryLink}
          href={href}
          data-qa="subtitle"
          onClick={() => clickEvent(categoryName, 'divisionNameLink')}
        >
          <Typography variant="l" size="subtitle" className={categoryLabel}>
            {categoryName}
          </Typography>
        </a>
        <ul className={subcategoryList} data-qa="sub-list">
          <AccordionList category={categoryName} renderCount={renderCount}>
            {children?.map(({ name, sitePath, isVisual }) => {
              const path = patchUrlByLocale(addSlashToEndString(sitePath));
              return isVisual ? (
                <li key={name}>
                  <LinkButton
                    className={subcategoryItem}
                    href={path}
                    size="m"
                    onClick={() => clickEvent(name, 'subdivisionNameLink')}
                  >
                    {name}
                  </LinkButton>
                </li>
              ) : null;
            })}
          </AccordionList>
        </ul>
      </div>
    </li>
  );
};
